export enum ExportType {
  JSON = 'json',
  PDF = 'pdf'
}
export const EXPORT_TYPE_TO_MIME_TYPE = new Map([
  [ExportType.JSON, 'application/json'],
  [ExportType.PDF, 'application/pdf']
]);
